import { useEffect, useState } from "react";
import { Permissions } from "@repo/database";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { SideNav } from "~/components/layout/side-nav";
import { DateRangePicker } from "~/components/ui/date-picker-range";
import { useNavigationManager } from "~/managers/use-navigation-manager";
import { usePermissionManager } from "~/managers/use-permission-manager";
import { usePermissionStore } from "~/stores/use-permission-store";
import { useReportStore } from "~/stores/use-report-store";

export const Route = createFileRoute("/_main/reports/_layout")({
  component: ReportLayout,
});

function ReportLayout() {
  const { t } = useTranslation("common");
  const { reportsNavItems } = useNavigationManager();
  const { range, setRange } = useReportStore();
  const { hasPermission } = usePermissionManager();
  const { currentEmployee } = usePermissionStore();

  const [permission, setPermission] = useState(false);

  useEffect(() => {
    if (!currentEmployee) {
      setPermission(false);
    }
    hasPermission({
      requiredPermission: Permissions.view_reports,
      label: t("Permissions.view_reports_label"),
    })
      .then((result) => {
        setPermission(result.permission);
      })
      .catch((e) => console.error(e));
  }, [hasPermission, currentEmployee, t]);

  if (!permission) return null;

  return (
    <div className="flex md:flex-row flex-col w-full h-full">
      <SideNav title={t("reports")} navItems={reportsNavItems} />
      <div className="max-w-7xl p-2 w-full mx-auto flex flex-col gap-4 overflow-auto">
        <div className="w-full">
          <DateRangePicker
            className="w-full"
            initialDateFrom={range.from}
            initialDateTo={range.to}
            onUpdate={(values) => {
              setRange(values.range);
            }}
          />
        </div>
        <div className="overflow-auto p-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
